/**
 * Team Inbox — compose a new outbound email from care@ (spec PART 3.1,
 * NEW-LIVE). Minimal: To / Subject / Body → `sendEmailToClient` (no-project).
 * Rich text + attachments are LATER.
 */
import { useState } from 'react';
import { CARE_EMAIL } from '../lib/emailStore';

export default function ComposeEmail({
  sending,
  err,
  onClose,
  onSend,
}: {
  sending: boolean;
  err: string | null;
  onClose: () => void;
  onSend: (to: string, subject: string, body: string) => Promise<boolean>;
}) {
  const [to, setTo] = useState('');
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');

  const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(to.trim());
  const canSend = validEmail && !!subject.trim() && !!body.trim() && !sending;

  async function submit() {
    if (!canSend) return;
    const ok = await onSend(to.trim(), subject.trim(), body.trim());
    if (ok) onClose();
  }

  return (
    <div className="ti-modal-backdrop" role="dialog" aria-modal aria-label="Compose email">
      <div className="ti-compose">
        <div className="ti-compose-head">
          <h3>New email</h3>
          <button type="button" className="ti-compose-x" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>
        <div className="ti-compose-from">From: <b>{CARE_EMAIL}</b></div>
        <label className="ti-compose-field">
          <span>To</span>
          <input
            type="email"
            value={to}
            onChange={(e) => setTo(e.target.value)}
            placeholder="recipient@example.com"
            aria-invalid={to.length > 0 && !validEmail}
          />
        </label>
        <label className="ti-compose-field">
          <span>Subject</span>
          <input
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            placeholder="Subject"
          />
        </label>
        <textarea
          className="ti-compose-body"
          value={body}
          onChange={(e) => setBody(e.target.value)}
          placeholder="Write your message…"
          rows={8}
        />
        {err && <div className="ti-send-err" role="alert">{err}</div>}
        <div className="ti-compose-row">
          <span className="ti-compose-hint">Sends as a real email from care@</span>
          <button type="button" className="ti-ec-send" disabled={!canSend} onClick={() => void submit()}>
            {sending ? 'Sending…' : 'Send email ➤'}
          </button>
        </div>
      </div>
    </div>
  );
}
